import Script from "src/component/script/Script";
import UIManifest from "src/engine/ui/UIManifest";
import { IInfo } from "./ExecScript";
import Utils from "src/lib/utils/Utils";
import CalcScript from "src/component/script/NumberCalcScript/CalcScript";

interface IEdgeScript {
    label: string;
    clearSpace: boolean;
}

const DefaultHeaders = () => {
    let datestr: any = `${new Date().getFullYear()}-01-01 00:00:00`;
    //兼容ios不支持
    datestr = datestr.replace(/\-/g, "/");
    return {
        YearTime: new Date(datestr).valueOf() / 1000,
    };
};

/**
 *
 *
 * @class EdgeScript
 */
@UIManifest.declare("GGEdge", "GGEdge脚本", UIManifest.Type.ScriptPrivate)
class EdgeScript extends Script<IEdgeScript> {
    private handleUrl(url: string, headers: any) {
        headers = { ...DefaultHeaders(), ...headers };

        if (url.indexOf("[") >= 0 && headers) {
            const list = Utils.parser(/\[(.+?)\]/gim, url, 1);
            list.map((item) => {
                if (headers[item] !== undefined) {
                    url = url.replace(`[${item}]`, headers[item]);
                }
            });
        }
        return url;
    }

    getItem(str: string, info: IInfo, len: number = 1) {
        // if()
        str = this.handleUrl(str, info.value);
        return str.slice(len, str.length);
    }

    calc(item: string, checkValue: string, info: IInfo) {
        const list = this.handleUrl(item, info.value).split("|");
        let bool;
        for (const i of list) {
            bool = CalcScript.calc(i[0] as any, checkValue, this.handleUrl(i.slice(1, i.length), info.value));
            if (bool === true) break;
        }
        return bool;
    }

    exec(info: IInfo) {
        const { label, clearSpace = true } = this.props;
        const item = clearSpace ? label.replace(/\s+/g, "") : label;
        if (item) {
            const checkValue = info.checkType !== undefined ? info.checkValue : info.value;
            //一位执行算法
            const value = this.calc(item, checkValue, info);
            // console.log("[EdgeScript]:", this.context.props.uiItem.ui, info, checkValue, item, value);
            // //取前2位执行算法
            //如果检测失败，则直接退出
            if (value === false) return false;
            if (value === true) return true;
            //如果没有检测，则修改toName
            if (value === undefined) {
                info.toName = this.handleUrl(label, typeof value === "object" ? value : { [info.toName || info.name]: info.value }) || info.name;
            }
            //如果进行过计算，则修改value
            else info.value = value;
        }
        return true;
    }
}

export default EdgeScript;
